import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import {AppBar, Box, IconButton, Toolbar} from '@mui/material';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {MAX_WIDTH_CONTAINER_NotImprotant} from '../../config/cacheKey';
import {RootState} from '../../redux/store';
import './appBar.css';
import {useNavigate} from 'react-router-dom';

const CustomizedAppBar = () => {
    const title = useSelector(
        (state: RootState) => state.headerTitleSlice.header
    );
    let color = useSelector((state: RootState) => state.headerTitleSlice.color);
    const display = useSelector(
        (state: RootState) => state.headerTitleSlice.display
    );
    let parentRoute = useSelector(
        (state: RootState) => state.headerTitleSlice.parentRoute
    );
    const navigate = useNavigate();
    useEffect(() => {
        if (color?.includes('linear-gradient')) {
            color = '#fff';
        }
        const metaThemeColor = document.querySelector(
            'meta[name="theme-color"]'
        );
        metaThemeColor!.setAttribute('content', color);
    }, [color]);

    return (
        <>
            <Box
                sx={{
                    pb: '63px',
                    display: `${display == 'none' ? 'none' : 'block'}`,
                }}
            >
                <AppBar
                    style={{
                        maxWidth: MAX_WIDTH_CONTAINER_NotImprotant,
                        // width: width > +MAX_WIDTH_CONTAINER_NotImprotant ? `calc(${MAX_WIDTH_CONTAINER_NotImprotant} - 40px)` : width - 40,
                        borderBottom:
                            color === 'var(--header-color)'
                                ? '1px solid var(--header-border-color)'
                                : '',
                        backgroundColor: color,
                    }}
                    className="appBarBackground appbarMedia containerMedia"
                    elevation={3}
                >
                    <Toolbar
                        sx={{
                            alignItems: 'center',
                            height: '100%',
                            display: 'flex',
                        }}
                    >
                        {parentRoute != null ? (
                            color !== 'transparent' && (
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    className={`appBarBackBtn`}
                                    sx={{
                                        color: 'var(--primary-text-color)',
                                        width: 'fit-content',
                                        marginLeft: '10px',
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    <ArrowForwardOutlinedIcon />
                                </IconButton>
                            )
                        ) : (
                            <></>
                        )}
                        <div className="appBarTitle">
                            <span
                                className={`font-bold text-sm 
                            text-[var(--primary-text-color)]
                          
                            `}
                            >
                                {title}
                            </span>
                        </div>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    );
};

export default CustomizedAppBar;
